/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  ReactElement,
} from 'react';
import styled, { useTheme } from 'styled-components';

import type {
  ClearIndicatorProps,
  GroupBase,
} from 'react-select';

import type {
  ReactSelectExtendedProps,
} from '../ReactSelectExtended';
import type {
  OptionTypeBase,
} from '../types';

const Wrapper = styled.button<{
  $isFocused: boolean;
  $small: boolean;
}>(({
  $isFocused,
  $small,

  theme: {
    colors,
    select,
  },
}) => ({
  display: 'flex',
  boxSizing: 'border-box',
  paddingTop: $small ? 3 : 8,
  paddingBottom: $small ? 3 : 8,
  paddingLeft: 7,
  paddingRight: 0,
  transition: 'color 150ms ease 0s',
  color: $isFocused
    ? colors[select.CLEAR_INDICATOR_COLOR_FOCUSED]
    : colors[select.CLEAR_INDICATOR_COLOR],
  minWidth: 23,

  background: 'transparent',
  border: 0,
  cursor: 'pointer',

  '&:hover': {
    color: colors[select.CLEAR_INDICATOR_COLOR_HOVER],
  },

  '&:active': {
    color: colors[select.CLEAR_INDICATOR_COLOR_ACTIVE],
  },
}));

export function ClearIndicator<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
Group extends GroupBase<OptionType>,
>({
  innerProps,
  isFocused,
  selectProps,
  className,
}: ClearIndicatorProps<OptionType, IsMulti, Group>): ReactElement {
  const {
    small,
  } = selectProps as ReactSelectExtendedProps<OptionType, IsMulti, Group>;
  const { select } = useTheme();

  return (
    <Wrapper
      {...innerProps as any}
      className={className}
      $small={small}
      $isFocused={isFocused}
      data-n3__select-clear-indicator=""
    >
      {select.CLEAR_INDICATOR_ICON}
    </Wrapper>
  );
}
